import { styled } from "styled-components";
import { RadioWrapper } from "@template/components/Radio/styles.ts";

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;

  ${RadioWrapper} {
    width: fit-content;
  }
`;
